import MapViewService from "./MapViewService";
import { FLOOD_RISK } from "./interface";
const FloodLikelihoodOptions = [
    {
        label: "Small flood - very high chance",
        value: FLOOD_RISK.VERY_HIGH,
        tooltip: `flood this size has almost a 100% chance of happening in an 80-year lifetime. This is also referred to as a 1 in 5 chance per year flood.`,
        displayTooltip: ""
    },
    {
        label: "Large flood - high chance",
        value: FLOOD_RISK.HIGH,
        tooltip: `flood this size has a 98% chance of happening in an 80-year lifetime. This is also referred to as a 1 in 20 chance per year flood.`,
        displayTooltip: ""
    },
    {
        label: "Very large flood - medium chance",
        value: FLOOD_RISK.MEDIUM,
        tooltip: `flood this size has a 55% chance of happening in an 80-year lifetime. This is also referred to as a 1 in 100 chance per year flood.`,
        displayTooltip: ""
    },
    {
        label: "Huge flood - low chance",
        value: FLOOD_RISK.LOW,
        tooltip: `flood this size has a 15% chance of happening in an 80-year lifetime. This is also referred to as a 1 in 500 chance per year flood.`,
        displayTooltip: ""
    },
    {
        label: "Biggest flood possible - extremely low chance",
        value: FLOOD_RISK.VERY_LOW,
        tooltip: `flood this size has less than a 0.1% chance of happening in an 80-year lifetime. This is the largest possible flood in the Hawkesbury-Nepean Valley, also known as the probable maximum flood (PMF).`,
        displayTooltip: ""
    }
];
export { MapLayers, FLOOD_RISK } from "./interface";
export { FloodLikelihoodOptions };
export default {
    MapViewSvc: new MapViewService()
};
